import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";

import {
    fetchProvinces,
    fetchCountryById,
    clearProvinces
} from "api/menu/master-files/locations/actions";

class ProvincesList extends React.Component {
    componentDidMount() {
        this.props.fetchProvinces(this.props.match.params.id);
        this.props.fetchCountryById(this.props.match.params.id);
    }

    componentWillUnmount () {
        this.props.clearProvinces();
    }

    getCountryName = () => {
        if (this.props.currentCountry && this.props.currentCountry.fullName) {
            return `of ${this.props.currentCountry.fullName}`;
        }
        return "";
    };

    render () {
        const { provinces } = this.props;


        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Name",
                accessor: "fullName",
                Cell: ({ original }) => (
                    <Link to={`/locations/provinces/${original.id}/cities`}>{original.fullName}</Link>
                ),
                id: "fullName",
            },
            {
                Header: "Active?",
                id: "inactive",
                accessor: original => (original.inactive ? "No" : "Yes"),
                Cell: ({ original }) => (original.inactive ? "No" : "Yes"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            /* {
                Header: "Actions",
                id: "actions",
                Cell: ({ original }) => (
                    <ButtonGroup>
                        <Button size="sm" onClick={() => this.handleClick(original.id)}>
                            <FontAwesomeIcon icon="search" title="Search / Replace" />
                        </Button>
                    </ButtonGroup>
                ),
                getProps: () => ({
                    style: {
                        justifyContent: "space-between",
                        whiteSpace: "unset"
                    }
                }),
                filterable: false
            } */
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">Provinces {this.getCountryName()}</h3>

                <ReactTable
                    data={provinces}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={false}
                    filterable
                    defaultSorted={[
                        {
                            id: "fullName",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "inactive",
                            value: "YES"
                        }
                    ]}
                    defaultFilterMethod={filterCaseInsensitive}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                />
            </div>
        );
    }
}

ProvincesList.propTypes = {
    fetchCountryById: PropTypes.func.isRequired,
    fetchProvinces: PropTypes.func.isRequired,
    clearProvinces: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    currentCountry: state.locations.currentCountry,
    provinces: state.locations.provinces,
});

const mapStateToDispatch = dispatch => ({
    fetchCountryById: bindActionCreators(fetchCountryById, dispatch),
    fetchProvinces: bindActionCreators(fetchProvinces, dispatch),
    clearProvinces: bindActionCreators(clearProvinces, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ProvincesList);
